import { localeNamespace } from '@internal/utils/machine/i18n/Locale'
import { MailOutlined, Phone, WhatsApp } from '@mui/icons-material'
import viberIcon from '@renderer-ui-library/assets/viber-logo-current-color-transparent.svg'
import { Button } from '@renderer-ui-library/atoms'
import { Stack, Typography } from '@renderer-ui-library/mui'
import { translations } from 'i18n/translations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import React, { MouseEvent } from 'react'
import { ImageLoader } from 'utils/media/ImageLoader'
import styles from './multipleFloatingButton.module.scss'

interface Props {
  handleClick: (event: MouseEvent<HTMLButtonElement>) => void
}

export const MultipleFloatingButtonDetailsOverlay: React.FC<Props> = React.memo(
  ({ handleClick }) => {
    const { t } = useTranslation(localeNamespace.common)
    return (
      <div className={styles.mobileDetailsWrapper}>
        <Button
          noMinWidth
          fullWidth
          fullHeight
          size='small'
          color='secondary'
          onClick={handleClick}
          variant='contained'
        >
          <Stack
            className={styles.iconContainer}
            direction='row'
            spacing={1}
            alignItems='center'
            component='span'
          >
            <Phone />
            <WhatsApp />
            <Image
              src={viberIcon}
              loading='lazy'
              alt=''
              loader={ImageLoader}
              width={18}
              height={18}
            />

            <MailOutlined />
          </Stack>

          <Typography variant='body2'>
            {t(
              translations.contactInformationWizardContactUsTitleAndButtonText
            )}
          </Typography>
        </Button>
      </div>
    )
  }
)

MultipleFloatingButtonDetailsOverlay.displayName =
  'MultipleFloatingButtonDetailsOverlay'
